import { SvgType } from './types'

export default function Archive({ fill, style, size, viewBox }: SvgType) {
  return (
    <svg
      width={size}
      height={size}
      style={style}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <mask maskUnits="userSpaceOnUse" x={2} y={3} width={20} height={17}>
          <g>
            <path d="M5 18C5.55228 18 6 17.5523 6 17C6 16.4477 5.55228 16 5 16C4.44772 16 4 16.4477 4 17C4 17.5523 4.44772 18 5 18ZM3 5V13H7V5H3ZM3 3H7C7.55228 3 8 3.44772 8 4V19C8 19.5523 7.55228 20 7 20H3C2.44772 20 2 19.5523 2 19V4C2 3.44772 2.44772 3 3 3ZM4 6H6V7H4V6ZM12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18ZM10 5V13H14V5H10ZM10 3H14C14.5523 3 15 3.44772 15 4V19C15 19.5523 14.5523 20 14 20H10C9.44772 20 9 19.5523 9 19V4C9 3.44772 9.44772 3 10 3ZM11 6H13V7H11V6ZM19 18C19.5523 18 20 17.5523 20 17C20 16.4477 19.5523 16 19 16C18.4477 16 18 16.4477 18 17C18 17.5523 18.4477 18 19 18ZM17 5V13H21V5H17ZM17 3H21C21.5523 3 22 3.44772 22 4V19C22 19.5523 21.5523 20 21 20H17C16.4477 20 16 19.5523 16 19V4C16 3.44772 16.4477 3 17 3ZM18 6H20V7H18V6Z" />
          </g>
        </mask>
        <g>
          <path
            d="M5 18C5.55228 18 6 17.5523 6 17C6 16.4477 5.55228 16 5 16C4.44772 16 4 16.4477 4 17C4 17.5523 4.44772 18 5 18ZM3 5V13H7V5H3ZM3 3H7C7.55228 3 8 3.44772 8 4V19C8 19.5523 7.55228 20 7 20H3C2.44772 20 2 19.5523 2 19V4C2 3.44772 2.44772 3 3 3ZM4 6H6V7H4V6ZM12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18ZM10 5V13H14V5H10ZM10 3H14C14.5523 3 15 3.44772 15 4V19C15 19.5523 14.5523 20 14 20H10C9.44772 20 9 19.5523 9 19V4C9 3.44772 9.44772 3 10 3ZM11 6H13V7H11V6ZM19 18C19.5523 18 20 17.5523 20 17C20 16.4477 19.5523 16 19 16C18.4477 16 18 16.4477 18 17C18 17.5523 18.4477 18 19 18ZM17 5V13H21V5H17ZM17 3H21C21.5523 3 22 3.44772 22 4V19C22 19.5523 21.5523 20 21 20H17C16.4477 20 16 19.5523 16 19V4C16 3.44772 16.4477 3 17 3ZM18 6H20V7H18V6Z"
            fill={fill}
          />
        </g>
      </g>
    </svg>
  )
}
